<div class="zoom-stack" [attr.data-testid]="testIdPrefix + '-zoom-controls'">
  <span class="zoom-pill" [class.zoom-pill--shown]="pillVisible" role="status" aria-live="polite" [attr.data-testid]="testIdPrefix + '-zoom'">{{ zoom | number: '1.0-1' }}×</span>
  <button type="button" class="map-action" aria-label="Zoom in" [attr.data-testid]="testIdPrefix + '-zoom-in'" [disabled]="!canZoomIn" (click)="zoomIn.emit()">
    <mat-icon svgIcon="plus" />
  </button>
  <button type="button" class="map-action" aria-label="Zoom out" [attr.data-testid]="testIdPrefix + '-zoom-out'" [disabled]="!canZoomOut" (click)="zoomOut.emit()">
    <mat-icon svgIcon="minus" />
  </button>
  @if (showFit) {
    <button type="button" class="map-action" aria-label="Fit the page" [attr.data-testid]="testIdPrefix + '-fit'" [disabled]="!canFit" (click)="fit.emit()">
      <mat-icon>fit_screen</mat-icon>
    </button>
  }
  @if (fullScreen !== null) {
    <button type="button" class="map-action" [attr.aria-label]="fullScreen ? 'Exit full screen' : 'Full screen'" [attr.data-testid]="testIdPrefix + '-fullscreen'"
      (click)="fullScreenChange.emit(!fullScreen)">
      <mat-icon [svgIcon]="fullScreen ? 'fullscreen-collapse' : 'full-screen'" />
    </button>
  }
</div>
